export async function GetDateTimeAudience(token: string | null, countryId: number | null) {

    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/DiaIbope?countryId=' + countryId,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }

    const request = await axios.request(options);
    return request;
}